import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    listProductOptions(formdata) {
        return API.post('listproductoptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listSupplierOptions(formdata) {
        return API.post('listsupplieroptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listLocationOptions(formdata) {
        return API.post('listlocationoptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listStoreProductsOptions(formdata) {
        return API.post('liststoreproductoptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listEntryBatch(formdata) {
        return API.post('listentrybatch', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listItemBatch(formdata) {
        return API.post('listitembatch', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listRoomOptions(formdata) {
        return API.post('listroomoptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listCustomerOptions(formdata) {
        return API.post('listcustomeroptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listBatchOptions(formdata) {
        return API.post('listbatchoptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
    listUserLocationOptions(formdata) {
        return API.post('listuserlocationoptions', httpBuildQuery(formdata)).then(res => (res.data));
    },
};
